export default {
  instruments: [
    {
      name: 'Bongo',
      audio: 'bongo',
      image: 'bongo.png'
    },
    {
      name: 'Cavaquinho',
      audio: 'cavaquinho',
      image: 'cavaquinho.png',
    },
    {
      name: 'Cordas',
      audio: 'cordas',
      image: 'cordas.png'
    },
    {
      name: 'Bateria Elétrica',
      audio: 'drummer',
      image: 'drums_eletric.png'
    },
    {
      name: 'Bateria',
      audio: 'drummer2',
      image: 'drums.png'
    },
    {
      name: 'Canto',
      audio: 'voice',
      image: 'voice.png'
    },
    {
      name: 'Guitarra',
      audio: 'guitarra',
      image: 'guitar.png'
    },
    {
      name: 'Piano',
      audio: 'piano',
      image: 'piano.png'
    },
    {
      name: 'Shaker',
      audio: 'shaker',
      image: 'shake.png'
    }
  ],
  numbers: [
    {
      name: 'one',
      audio: 'one',
      image: 'one.png'
    },
    {
      name: 'two',
      audio: 'two',
      image: 'two.png',
    },
    {
      name: 'three',
      audio: 'three',
      image: 'three.png'
    },
    {
      name: 'four',
      audio: 'four',
      image: 'four.png'
    },
    {
      name: 'five',
      audio: 'five',
      image: 'five.png'
    },
    {
      name: 'six',
      audio: 'six',
      image: 'six.png'
    },
    {
      name: 'seven',
      audio: 'seven',
      image: 'seven.png'
    },
    {
      name: 'eight',
      audio: 'eight',
      image: 'eight.png'
    },
    {
      name: 'nine',
      audio: 'nine',
      image: 'nine.png'
    }
  ],
  words: {
    pt: [
      {
        name: 'uva',
        audio: 'uva',
        image: 'uva.svg'
      },
      {
        name: 'anel',
        audio: 'anel',
        image: 'anel.svg'
      },
      {
        name: 'luva',
        audio: 'luva',
        image: 'luva.svg'
      },
      {
        name: 'chapeu',
        audio: 'chapeu',
        image: 'chapeu.svg'
      },
      {
        name: 'porta',
        audio: 'porta',
        image: 'porta.svg'
      },
      {
        name: 'bata',
        audio: 'bata',
        image: 'bata.svg'
      },
      {
        name: 'limao',
        audio: 'limao',
        image: 'limao.svg'
      },
      {
        name: 'urso',
        audio: 'urso',
        image: 'urso.svg'
      },
      {
        name: 'rosa',
        audio: 'rosa',
        image: 'rosa.svg'
      }
    ],
    en: [
      {
        name: 'bear',
        audio: 'bear',
        image: 'bear.svg'
      },
      {
        name: 'nose',
        audio: 'nose',
        image: 'nose.svg',
      },
      {
        name: 'door',
        audio: 'door',
        image: 'door.svg'
      },
      {
        name: 'house',
        audio: 'house',
        image: 'house.svg'
      },
      {
        name: 'book',
        audio: 'book',
        image: 'book.svg'
      },
      {
        name: 'chair',
        audio: 'chair',
        image: 'chair.svg'
      },
      {
        name: 'phone',
        audio: 'phone',
        image: 'phone.svg'
      },
      {
        name: 'jar',
        audio: 'jar',
        image: 'jar.svg'
      },
      {
        name: 'ball',
        audio: 'ball',
        image: 'ball.svg'
      }
    ]
  },
  categorized: {
    music: ['gospel'],
    strings: ['cavaquinho', 'cordas', 'cordas2', 'guitarra'],
    keyboard: ['piano'],
    percurssion: ['drummer', 'drummer2', 'bongo', 'shaker']
  }
}